// Description: Functions for handling popups.
//
// Refactored to use ES6 syntax and functions.

/**
 * Global popup settings.
 */
const popupFadeInterval = 5;

/**
 * Initializes persistent popups.
 */
const initPersistentPopups = () => {
    const persistentPopups = document.querySelectorAll(".popup-keep-open");
    if (persistentPopups.length > 0) {
        lockPageScroll();
    }
};

/**
 * Opens a popup with the given ID.
 * @param {string} popupId - The ID of the popup to open.
 */
const openPopup = (popupId) => {
    const popup = document.querySelector(popupId);
    if (popup) {
        //document.getElementById(`${popup.id}-render-action`).value = 1; will stop it from closing
        popup.style.opacity = 0;
        popup.style.display = 'block';
        let opacity = 0;
        const fadeInInterval = setInterval(() => {
            opacity += 0.05;
            popup.style.opacity = opacity;
            if (opacity >= 1) {
                clearInterval(fadeInInterval);
                lockPageScroll();
            }
        }, popupFadeInterval);
    }
};

/**
 * Closes a popup with the given ID.
 * @param {string} popupId - The ID of the popup to close.
 */
const closePopup = (popupId) => {
    const popup = document.querySelector(popupId);
    if (popup) {
        document.getElementById(`${popup.id}-render-action`).value = 2;
        let opacity = 1;
        const fadeOutInterval = setInterval(() => {
            opacity -= 0.05;
            popup.style.opacity = opacity;
            if (opacity <= 0) {
                clearInterval(fadeOutInterval);
                popup.style.display = "none";
                popup.classList.remove('popup-keep-open');
                unlockPageScroll();
            }
        }, popupFadeInterval);
    }
};

/**
 * Locks the page scroll.
 */
const lockPageScroll = () => {
    const outerWrapper = document.body;
    outerWrapper.classList.add('body-no-scroll');
    if (window.innerHeight < outerWrapper.offsetHeight) {
        outerWrapper.classList.add('body-disable-scrollbar');
    }
};

/**
 * Unlocks the page scroll.
 */
const unlockPageScroll = () => {
    const outerWrapper = document.body;
    outerWrapper.classList.remove('body-no-scroll');
    outerWrapper.classList.remove('body-disable-scrollbar');
};
